/* va-dup.js — "Duplicate & edit": re-open a past design in the builder as a NEW design.
   Entry: /?d=<template>&dup=<designId>&sig=<hmac>
   Nothing here writes _design_id. Add-to-cart (#va-mconfirm) mints a fresh vault
   record from the DOM, so the original order is never touched. The `d=` param is
   load-bearing: it makes va-builder's own vaPrefill() pick the template, sets
   hadUrl so a stale va_draft cannot clobber the duplicate, and un-gates the form. */
(function () {
  var q; try { q = new URLSearchParams(location.search); } catch (_) { return; }
  var id  = q.get('dup') || '',
      sig = String(q.get('sig') || '').toLowerCase(),
      tpl = q.get('d') || '';
  if (!/^[A-Za-z0-9]{2,40}$/.test(id) || !/^[a-f0-9]{64}$/.test(sig)) return;

  var BASE = String(window.VA_DESIGN_URL || 'https://vialart-design.vialart.workers.dev/design')
               .replace(/\/design\/?$/, '');
  function el(i) { return document.getElementById(i); }
  function sv(i, v) { var e = el(i); if (e && v != null && v !== '') e.value = v; }
  function fire(e, t) { try { e.dispatchEvent(new Event(t, { bubbles: true })); } catch (_) {} }

  /* ---------- banner ---------- */
  function note(msg, warn) {
    var b = el('va-dup-note');
    if (!b) {
      b = document.createElement('div'); b.id = 'va-dup-note';
      b.style.cssText = 'margin:10px 0;padding:10px 13px;border-radius:11px;font-size:12.5px;' +
        'font-weight:700;line-height:1.45;border:1px solid rgba(124,77,255,.38);' +
        'background:rgba(124,77,255,.10);color:#cdc4e8;';
      var host = el('va-name'); host = host && host.closest('.va-field');
      if (host && host.parentNode) host.parentNode.insertBefore(b, host); else return;
    }
    b.textContent = msg;
    if (warn) { b.style.borderColor = 'rgba(255,196,0,.45)'; b.style.background = 'rgba(255,196,0,.10)'; b.style.color = '#ffd98a'; }
  }

  /* ---------- fetch: full spec, then the lite header as a fallback ---------- */
  var full = fetch(BASE + '/design/' + encodeURIComponent(id) + '/edit?sig=' + encodeURIComponent(sig),
                   { cache: 'no-store', mode: 'cors' })
    .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });

  function lite() {   /* same decoder as snippets/cart-products.liquid _vaFields */
    return fetch(BASE + '/preview/' + encodeURIComponent(id) + '?sig=' + encodeURIComponent(sig),
                 { cache: 'no-store', mode: 'cors' })
      .then(function (r) {
        var h = r.headers.get('X-VA-Fields'); if (!h) return null;
        var bin = atob(h), u = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i);
        return JSON.parse(new TextDecoder().decode(u));
      }).catch(function () { return null; });
  }

  /* ---------- wait for the builder: catalog loaded AND vaPrefill() has run ---------- */
  function ready(cb) {
    var n = 0;
    (function poll() {
      var ok = typeof window.renderAll === 'function' &&
               window.DESIGNS && window.DESIGNS.length &&
               window.sel && (!tpl || window.sel.key === tpl);
      if (ok) return cb(true);
      if (++n > 80) return cb(false);          /* ~10s */
      setTimeout(poll, 125);
    })();
  }

  /* ---------- hydrate ---------- */
  function applyDose(dose) {
    if (!dose) return;
    var dm = /^\s*([\d.]+)\s*(.*)$/.exec(dose);          /* same split as vaPrefill() */
    if (!dm) { sv('va-dose', dose); return; }
    sv('va-dose', dm[1]);
    var u = (dm[2] || '').trim(), us = el('va-doseu');
    if (!us || !u) return;
    var found = false, i;
    for (i = 0; i < us.options.length; i++) if (us.options[i].value === u) { found = true; break; }
    if (found) us.value = u;
    else { us.value = '__c'; sv('va-doseuc', u); }
    fire(us, 'change');
  }

  function applyLogo(p) {
    if (!p.logo || String(p.logo).indexOf('data:image') !== 0) return;
    window.customLogo = p.logo; window._vaLogoBase = p.logo;
    window.logoScale = (p.logoScale == null ? 1 : +p.logoScale) || 1;
    window.logoX = +p.logoX || 0; window.logoY = +p.logoY || 0;
    try { window.dispatchEvent(new Event('va-logo-changed')); } catch (_) {}
    var rm = el('va-logo-rm');            if (rm)  rm.style.display = '';
    var sw = el('va-logo-scale-wrap');    if (sw)  sw.style.display = '';
    var sl = el('va-logo-scale');
    if (sl) sl.value = Math.round(window.logoScale * 100);
    var sx = el('va-logo-scaleval');
    if (sx) sx.textContent = Math.round(window.logoScale * 100) + '%';
    var nm = el('va-logo-name');
    if (nm) nm.textContent = 'Your saved logo ✓ reopened from your last order';
  }

  function applyHideMark(p) {
    var cb = el('va-logo-hidemark'); if (!cb) return;
    var want = !!p.hideMark; if (cb.checked === want) return;
    cb.checked = want; fire(cb, 'change');   /* va-flow2 handler sets window.vaHideMark */
  }

  function applyCaptions(p, tries) {
    var box = document.querySelector('#va-cap-box, .va-cap-box');
    if (!box) { if ((tries || 0) < 12) return setTimeout(function () { applyCaptions(p, (tries || 0) + 1); }, 250); return; }
    [['form', 'Caption Form'], ['route', 'Caption Route'], ['store', 'Caption Store'], ['ruo', 'Caption RUO']]
      .forEach(function (pair) {
        if (!(pair[1] in p)) return;                       /* absent = template default */
        var inp = box.querySelector('input.va-cap-inp[data-cap="' + pair[0] + '"]');
        if (!inp) return;
        inp.value = String(p[pair[1]] || '');
        fire(inp, 'input');                                /* -> vals + syncProps + patchAll */
      });
  }

  function hydrate(spec, l) {
    var p = (spec && spec.props) || {};
    var name = p['Custom Text']   != null ? p['Custom Text']   : (l && l.name) || '';
    var dose = p['Concentration'] != null ? p['Concentration'] : (l && l.dose) || '';
    var lot  = p['Lot']           != null ? p['Lot']           : (l && l.lot)  || '';
    var exp  = p['Expiration']    != null ? p['Expiration']    : (l && l.exp)  || '';
    var epfx = typeof p['Exp Label'] === 'string' ? p['Exp Label'] : ((l && l.epfx) || 'EXP');
    var qr   = p['QR URL']        != null ? p['QR URL']        : (l && l.qr)   || '';
    var mat  = (spec && spec.material) || (l && l.mat) || '';

    sv('va-name', name);
    applyDose(dose);

    if (typeof window.vaFldSet === 'function') window.vaFldSet('va-lot', !!lot);
    if (lot) sv('va-lot', lot);

    if (typeof window.vaFldSet === 'function') window.vaFldSet('va-exp', !!exp);
    if (exp) {
      var et = el('va-exp-type'); if (et) { et.value = epfx; fire(et, 'change'); }
      var ee = el('va-exp');
      if (ee) { ee.value = exp; fire(ee, 'change'); }   /* direct write skips the past-date confirm() */
    }

    sv('va-qr', qr);

    var hex = String(p['Accent Color'] || '').trim();    /* AFTER pickDesign — it clobbers #va-color */
    if (/^#[0-9a-fA-F]{3,8}$/.test(hex)) {
      try { if (typeof window.vaSetColor === 'function') window.vaSetColor(hex); } catch (_) {}
      var cel = el('va-color');
      if (cel && String(cel.value).toLowerCase() !== hex.toLowerCase()) {  /* vaSetColor rejects lum>190 */
        cel.value = hex;
        if (typeof window.vaRenderSwatches === 'function') window.vaRenderSwatches();
      }
    }

    applyLogo(p);
    applyHideMark(p);
    applyCaptions(p);

    if (mat && typeof window.selectMat === 'function') window.selectMat(mat);
    if (typeof window.renderAll === 'function') window.renderAll();
    if (typeof window.updateSummary === 'function') window.updateSummary();
  }

  /* ---------- drive it ---------- */
  full.then(function (spec) {
    return spec ? { spec: spec, l: null } : lite().then(function (l) { return { spec: null, l: l }; });
  }).then(function (got) {
    ready(function (builderOk) {
      if (!got.spec && !got.l) {
        note('We could not reopen that design — designs are kept for about 13 months. ' +
             'Pick a style below and build a fresh one.', 1);
        return;
      }
      hydrate(got.spec, got.l);
      if (!builderOk) { note('Reopened your design — double-check every field before you add to cart.', 1); return; }
      if (got.spec) {
        note('✏️ Editing a COPY of "' + (got.spec.design || 'your label') +
             '". Change the name, dose, or anything else — your original order is unchanged.');
      } else {
        note('✏️ Editing a COPY — heads up: your logo and accent colour could not be ' +
             'reopened. Re-upload the logo and re-pick the colour before adding to cart.', 1);
      }
    });
  });
})();
